export default {"src":"/_next/static/media/store_v2_supported_payments_final.439090bd.svg","height":32,"width":393,"blurWidth":0,"blurHeight":0};